exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding-80{padding:40px}.work-sans-font{font-family:\"Work Sans\"}.font-serif{font-family:\"serif\"}.fs-30px{font-size:25px}.grey{color:gray}.bg-white{background-color:#fff}.separator{height:1px;background-color:rgba(128,128,128,.15)}.custom-checkbox{font-size:.9rem}.custom-checkbox a{text-decoration:underline}.custom-checkbox a:hover{color:#4d4d4d}.fees-card{max-width:325px;background-color:#2e3e52;border-radius:15px;color:#fff}.extra-small{font-size:.8rem;line-height:.8rem}.small{font-size:.9rem;line-height:.9rem}.medium{font-size:1.1rem;line-height:1.1rem}.large{font-size:1.7rem;line-height:1.7rem}.bold{font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/payment-processing/merchant-onboarding/styles/styles.scss
// module id = 5946
// module chunks = 0